import * as React from 'react';
import Cookies from 'js-cookie';
import { IExternalLoginData, PARAM_LOGIN_EXTERNAL, } from 'src/app/redux/modules/auth/interfaces/IAuthData';
import ILoginStepProps from 'src/layouts/unauthorized/Login/components/ILoginStepProps';
import RestService from 'src/app/services/rest/RestService/RestService';
import LoadingOverlay from "src/components/LoadingOverlay/LoadingOverlay";

class SsoStep extends React.Component<ILoginStepProps> {

  public componentDidMount() {
    const { data } = this.props;
    const { currentSchema, redirectUrl } = data;

    if (!currentSchema) {
      return;
    }

    const externalLoginData: IExternalLoginData = {
      id: currentSchema.id || '',
      email: data.email,
      type: currentSchema.schema,
      error: false,
    };

    Cookies.set(PARAM_LOGIN_EXTERNAL, JSON.stringify(externalLoginData));

    let loginUrl = `${RestService.SSO_LOGIN_URL}/${currentSchema.id}`;

    if (redirectUrl) {
      loginUrl += `?redirect_url=${redirectUrl}`;
    }

    window.location.replace(loginUrl);
  }

  public render() {
    return (<LoadingOverlay active={true} spinner={true}/>);
  }
}

export default SsoStep;
